import axios from 'axios';

import { ProductBookingResponse } from 'store/ProductBooking/ProductBooking.interface';

import urls from 'utils/urls';
import PaginatedResponseInterface from './pageination.interface';

export const getProductBookingService: (
  page: number,
  params: any
) => Promise<PaginatedResponseInterface<ProductBookingResponse[]>> = async (page: number, params: any) => {
  try {
    const res = await axios.get(urls.productBookings + params);
    return {
      data: res.data.response.data,
      pageMeta: {
        currentPage: res.data.response.currentPage,
        totalItems: res.data.response.totalItems,
        totalPages: res.data.response.totalPages,
      },
    };
  } catch (ex) {
    return Promise.reject(ex);
  }
};
